export default __webpack_public_path__ + "static/media/Animations_Circle13.480f1048.svg";